"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.getSubscriptionTrackerSteps = void 0;
const ESignatureStatus_1 = require("../enums/Signature/ESignatureStatus");
const ESubscriptionSignatureType_1 = require("../enums/Signature/ESubscriptionSignatureType");
const ESubStep_1 = require("../enums/Subscription/ESubStep");
function getSubscriptionTrackerSteps(signatures, step, withoutRto) {
    const steps = { signatureRto: "inactive", signatureSubscription: "inactive", sendSignedDocuments: "inactive", validation: "inactive" };
    if (!signatures.length)
        return steps;
    const subscriptionSignature = signatures.find((signature) => signature.type === ESubscriptionSignatureType_1.ESubscriptionSignatureType.subscription);
    if (!withoutRto) {
        const rtoSignature = signatures.find((signature) => signature.type === ESubscriptionSignatureType_1.ESubscriptionSignatureType.rto) ?? (subscriptionSignature?.includesRto ? subscriptionSignature : undefined);
        if (!rtoSignature)
            return steps;
        const isRtoSigned = rtoSignature.status === ESignatureStatus_1.ESignatureStatus.done;
        steps.signatureRto = isRtoSigned ? "done" : "active";
        if (!isRtoSigned)
            return steps;
    }
    if (!subscriptionSignature)
        return steps;
    const isSubscriptionSigned = subscriptionSignature.status === ESignatureStatus_1.ESignatureStatus.done || (subscriptionSignature.sequentialCounterSignature === true && subscriptionSignature.investorSigned === true);
    steps.signatureSubscription = isSubscriptionSigned ? "done" : "active";
    if (!isSubscriptionSigned)
        return steps;
    if (step === ESubStep_1.ESubStep.waiting_transfer_sg) {
        steps.sendSignedDocuments = "active";
    }
    else if (step === ESubStep_1.ESubStep.waiting_validation || step === ESubStep_1.ESubStep.validated) {
        steps.sendSignedDocuments = "done";
    }
    if (step === ESubStep_1.ESubStep.waiting_validation) {
        steps.validation = "active";
    }
    else if (step === ESubStep_1.ESubStep.validated) {
        steps.validation = "done";
    }
    return steps;
}
exports.getSubscriptionTrackerSteps = getSubscriptionTrackerSteps;
